import PickUpOrderLocation from 'components/Checkout/Sections/PickUpOrderLocation/PickUpOrderLocation';

export default PickUpOrderLocation;
